// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2yadD","notes":"Notes_notes__2a54x","note":"Notes_note__3wEnv","markdown":"Notes_markdown__1nMAy"};